<template>
  <div class="home-page">
    <WelcomeScreen />
    <ServiceTitle />
    <ServiceBlock />
    <BarbersBlock
      @click-barbers-pop = "barbersPop = true"
      @changeNavNum = "changeNavNum($event)"
    />
    <InstaBlock />
    <ProductsImg />
    <ProductsBlock />
    <ContactsBlock />
    
    <transition name="modal">
    <BarbersPop
      v-if = "barbersPop"
      @close-barbers-pop = "barbersPop = false"
      :navigationNum = NavNumNew
    />
    </transition>

    <Header />

    <Loading
      v-if = "loading"
      @close="loading = false"
    />
  </div>
</template>

<script>
import WelcomeScreen from '@/components/home/parts/WelcomeScreen'
import ServiceTitle from '@/components/home/parts/ServiceTitle'
import ServiceBlock from '@/components/home/parts/ServiceBlock'
import BarbersBlock from '@/components/home/parts/BarbersBlock'
import InstaBlock from '@/components/home/parts/InstaBlock'
import ProductsImg from '@/components/home/parts/ProductsImg'
import ProductsBlock from '@/components/home/parts/ProductsBlock'
import ContactsBlock from '@/components/home/parts/ContactsBlock'
import BarbersPop from '@/components/home/parts/BarbersPop'

import Header from '@/components/home/parts/Header'
import Loading from '@/components/Loading'

export default {
  name: 'home-page',
  data () {
    return {
      barbersPop: false,
      loading: true,
      NavNumNew: 1
    }
  },
  components: {
    WelcomeScreen,
    ServiceTitle,
    ServiceBlock,
    BarbersBlock,
    InstaBlock,
    ProductsImg,
    ProductsBlock,
    ContactsBlock,
    BarbersPop,
    Header,
    Loading,
  },
  methods: {
    changeNavNum: function(changedNavNum) {
      this.NavNumNew = changedNavNum
    }
  },
  mounted () {
    //Bind ESC to close modals
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.barbersPop = false
      }
    })
  }
}
</script>
